export const fetchGet = (url, params = {}) => {
    const query = new URLSearchParams(params).toString();
    return fetch(`${url}?${query}`, {
        mode: 'cors',
        credentials: 'omit'
    }).then(response => {
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
    }).catch(error => {
        // Silently fail for non-critical tracking requests
        console.warn('Fetch failed:', error.message);
        return { success: false, error: error.message };
    });
}

export const fetchPost = (url, body, params = {}) => {
    const query = new URLSearchParams(params).toString();
    return fetch(`${url}?${query}`, {
        method: "POST",
        mode: 'cors',
        credentials: 'omit',
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(body)
    }).then(response => {
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
    }).catch(error => {
        console.warn('Fetch failed:', error.message);
        return { success: false, error: error.message };
    });
}
